import { defineMeta } from '@/registry/types';

export const filterPanelMeta = defineMeta({
  name: 'FilterPanel',
  level: 'organism',
  category: 'input',
  classification: 'custom',
  description: 'Container for filter controls with header and apply/clear actions.',
  baseLibrary: 'custom',
  muiEquivalent: 'Box (composed)',
  a2uiEquivalent: 'FilterPanel',
  importPath: '@/organisms/FilterPanel',
  requiredProps: ['children'],
  optionalProps: ['title', 'onApply', 'onClear', 'activeCount'],
  supportedStates: ['default', 'has-active-filters'],
  designTokens: ['colors', 'radius', 'spacing', 'typography'],
  accessibility: ['Group related controls with FormField labels.'],
  usageExamples: ['<FilterPanel title="Filters" onApply={apply} onClear={clear}><Search/></FilterPanel>'],
  rules: [
    'The header title is subtitle2 and the active-count is caption. Pass `title` — do not rebuild the header from Typography.',
  ],
  antiPatterns: ['Do not place unrelated actions in the footer.'],
  mountsSurface: 'inline',
  llmSafe: true,
  whenToUse: ['Table/list filtering sidebars and popovers'],
  whenNotToUse: ['Single search field (use Search)'],
});

export default filterPanelMeta;
